var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BrowserLayout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('BrowserNavigation')]},proxy:true},{key:"default",fn:function(){return [_c('BrowserPage',{model:{value:(_vm.selectedElements),callback:function ($$v) {_vm.selectedElements=$$v},expression:"selectedElements"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }